import { AccountMeta } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';

export const getUserShipTos = async (token: string, userId: string) => {
  const { data } = await apiInstance(token).get(`/account/${userId}/ship-to`);

  return data;
};

export const getAccountMeta = async (token: string) => {
  const { data } = await apiInstance(token).get<AccountMeta>('/account/me');
  return data;
};
